export default "__VITE_ASSET__DfihXdj1__"